<mat-toolbar class=toolbar>
    <div class="left fx-flex-40 fx-align-start">

        <div class=title>
            GP MANAGER
        </div>
    </div>

    <div class="fx-align-center fx-flex-20">
        <img class=logo src="assets/images/logo.png" routerLink="/home">
    </div>

    <div class="right fx-flex-40 fx-align-end">        
        <span style="font-size: 15px; padding-right: 16px;">
            BENVENUTO <strong>{{user?.firstName || ""}} {{user?.lastName || ""}}</strong> il tuo ruolo è: <strong><u>{{this.utils.myRole}}</u></strong>
        </span>
            
        <button class="logout-button padding-4x" mat-raised-button color=warn (click)="onLogout()">
            <mat-icon>logout</mat-icon>
            LOGOUT
        </button>    
    </div>
</mat-toolbar>